import { z } from 'zod';

import { apiClient } from './client';

const titleMediaSchema = z.object({
  name: z.string(),
  screenshots: z
    .array(z.string())
    .nullish()
    .transform((value) => value ?? []),
});
const responseSchema = z.object({ data: z.array(titleMediaSchema) });
export type MediaKind = 'film' | 'series' | 'game' | 'anime';

export const titleMediaApi = {
  async find(name: string, kind: MediaKind): Promise<string[]> {
    const response = responseSchema.parse(await apiClient.titles.search({ q: name, kind, limit: 20 }));
    const normalized = name.trim().toLocaleLowerCase('ru');
    return response.data.find((title) => title.name.trim().toLocaleLowerCase('ru') === normalized)?.screenshots ?? [];
  },
};
